angular
    .module('festzelt-os.documents.templates')
    .factory('restoreDocumentTemplate', [
        '$injector',
        ($injector) => new RestoreDocumentTemplateWorkflow($injector)
    ]);

class RestoreDocumentTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.api = $injector.get('$http');
        this.alert = $injector.get('$http');

        this.level = 'archived-highlight';
        this.order = 10;
        this.title = this.translate.instant('general.verbs.restore');
        this.icon = 'undo';
        this.key = 'restore-document-template';
    }

    action(documentTemplate, vm) {
        return this.api
            .put(`documents/templates/${documentTemplate.id}/restore`)
            .then(
                () => {
                    vm._loadModel()
                        .then(() => {
                            vm._prepareNavServiceStuff();
                        });
                    return this.alert.success(
                        this.translate.instant('general.alerts.restore_success.title'),
                        this.translate.instant('general.alerts.restore_success.content')
                    );
                }
            )
            .catch(err => this.alert.handle(err));
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/details/restore-template.js